@use '../../styling/typography.scss' as *;

.LockDescription {
  @extend %font-family-primary;

  font-size: $font-size-normal;
}
